// extracted by mini-css-extract-plugin
export default {"comp":"BacthModuleTypeSelect_comp__FHCdZ"};